var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTv = function SvgTv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M11.664 3H8.331c-3.143 0-4.714 0-5.69.976-.977.977-.977 2.548-.977 5.69s0 4.715.976 5.691c.977.976 2.548.976 5.69.976h3.334c3.143 0 4.714 0 5.69-.976.977-.976.977-2.548.977-5.69s0-4.714-.977-5.69C16.378 3 14.807 3 11.664 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m15 16.334.833 1.667M4.997 16.334l-.833 1.667"
  })));
};
export default SvgTv;